// jQuery
jQuery(function ($) {
  //
});

// スクロールフェードイン
const scrollTriggers = document.querySelectorAll("[data-scroll-trigger]");
const triggerPoint = 0.3; // 要素が表示されるトリガーポイント画面の30%

const handleScrollVisible = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        handleScrollVisible.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  },
  {
    threshold: triggerPoint,
  }
);
for (const scrollTrigger of scrollTriggers) {
  handleScrollVisible.observe(scrollTrigger);
}

// ハンバーガーメニュー
const body = document.getElementsByTagName("body");
const hamburger = document.getElementById("hamburger");
const headerNav = document.querySelector(".header .hamburger-menu");
const pageLinks = document.querySelectorAll('.gnav a[href*="#"]');

headerNav.classList.add("dNone");
hamburger.addEventListener("click", function () {
  body[0].classList.toggle("is-open");
  if (body[0].classList.contains("is-open") == true) {
    headerNav.classList.remove("dNone");
    setTimeout(function () {
      headerNav.classList.add("fadein");
    }, 1);
  } else {
    headerNav.classList.remove("fadein");
    setTimeout(function () {
      headerNav.classList.add("dNone");
    }, 100);
  }
});

// ページ内リンクをクリックした時にgnavを閉じる処理
pageLinks.forEach((link) => {
  link.addEventListener("click", () => {
    // メニューを閉じる処理
    body[0].classList.remove("is-open");
    headerNav.classList.remove("fadein");
    setTimeout(function () {
      headerNav.classList.add("dNone");
    }, 600);
  });
});

// swiper front-page hero
const swiper1 = new Swiper(".top-hero__swiper", {
  loop: true,
  autoplay: {
    delay: 2000,
  },
  speed: 2000,
  effect: "fade",
});

// swiper front-page service
const slideLength = document.querySelectorAll(".top-service__swiper .swiper-slide").length;
const SwiperService = () => {
  const Swiper2 = new Swiper(".top-service__swiper", {
    slidesPerView: 1.8,
    spaceBetween: 24,
    loop: true,
    loopedSlides: slideLength,
    speed: 8000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      769: {
        slidesPerView: 4.5,
      },
    },
  });
};

window.addEventListener("load", function () {
  SwiperService();
});

// swiper works-single
const works_swiper_thumb = new Swiper(".works-single__thumbnail", {
  slidesPerView: 4,
  spaceBetween: 8,
  grabCursor: true,
  breakpoints: {
    600: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
});
const works_swiper = new Swiper(".works-single__swiper", {
  loop: true,
  // autoplay: {
  //   delay: 2000,
  //   disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  // },
  allowTouchMove: false,
  speed: 500,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    clickable: false,
  },
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: works_swiper_thumb,
  },
});

// ヘッダー スクロール fixed付与
// const heroElement = document.querySelector("[data-header-fixed-trigger]");
// const headerElement = document.querySelector(".header");

// if (heroElement) {
//   // heroElementが存在する場合のみ実行
//   const handleHeaderFixed = new IntersectionObserver(
//     ([entry]) => {
//       if (!entry.isIntersecting) {
//         headerElement.classList.add("is-fixed");
//       } else {
//         headerElement.classList.remove("is-fixed");
//       }
//     },
//     {
//       threshold: 0, // heroElement が少しでも見えなくなったら is-fixed を付与
//     }
//   );

//   handleHeaderFixed.observe(heroElement);
// }
